module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/330.42ce3455.png";